export default __webpack_public_path__ + "static/media/company.a26bea1d.svg";